import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: null,
  status: 'idle',
  error: null,
  addUserStatus: 'idle',
  addUserError: null,
  editUserStatus: 'idle',
  editUserError: null,
  deleteUserStatus: 'idle',
  deleteUserError: null,
  companyUsers: null,
  companyUsersLoaded: false,
  companyUsersError: null,
  collectionUsers: null,
  collectionUsersLoaded: false,
  collectionUsersError: null,
  addUserCollectionError: null,
  addUserCollectionLoading: false,
  removeUserCollectionError: null,
  removeUserCollectionLoading: false,
  selectEditUser: null,
  resetPwdLoading: false,
  resetPwdError: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    getCompanyUsersStart: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    getCompanyUsersSuccess: (state, action) => {
      state.status = 'success';
      state.users = action.payload.data;
      state.error = null;
    },
    getCompanyUsersFailure: (state, action) => {
      state.status = 'fail';
      state.error = action.payload.message;
    },
    addUserStart: (state) => {
      state.addUserStatus = 'loading';
      state.addUserError = null;
    },
    addUserSuccess: (state) => {
      state.addUserStatus = 'success';
      state.addUserError = null;
    },
    addUserFailure: (state, action) => {
      state.addUserStatus = 'fail';
      state.addUserError = action.payload.message;
    },
    editUserStart: (state) => {
      state.editUserStatus = 'loading';
      state.editUserError = null;
    },
    editUserSuccess: (state) => {
      state.editUserStatus = 'success';
      state.editUserError = null;
    },
    editUserFailure: (state, action) => {
      state.editUserStatus = 'fail';
      state.editUserError = action.payload.message;
    },
    fetchCompanyUsersStart: (state) => {
      state.companyUsersLoaded = false;
      state.companyUsers = null;
      state.companyUsersError = null;
    },
    fetchCompanyUsersSuccess: (state, action) => {
      state.companyUsers = action.payload.data;
      state.companyUsersLoaded = true;
    },
    fetchCompanyUsersError: (state, action) => {
      state.companyUsers = null;
      state.companyUsersError = action.payload.message;
      state.companyUsersLoaded = true;
    },
    fetchCollectionUsersStart: (state) => {
      state.collectionUsers = null;
      state.collectionUsersLoaded = false;
      state.collectionUsersError = null;
    },
    fetchCollectionUsersSuccess: (state, action) => {
      state.collectionUsers = action.payload.data;
      state.collectionUsersLoaded = true;
    },
    fetchCollectionUsersError: (state, action) => {
      state.collectionUsers = null;
      state.collectionUsersError = action.payload.message;
      state.collectionUsersLoaded = true;
    },
    addUserToCollectionStart: (state) => {
      state.addUserCollectionError = null;
      state.addUserCollectionLoading = true;
    },
    addUserToCollectionSuccess: (state) => {
      state.addUserCollectionError = null;
      state.addUserCollectionLoading = false;
    },
    addUserToCollectionFailure: (state, action) => {
      state.addUserCollectionError = action.payload.message;
      state.addUserCollectionLoading = false;
    },
    removeUserFromCollectionStart: (state) => {
      state.removeUserCollectionError = null;
      state.removeUserCollectionLoading = true;
    },
    removeUserFromCollectionSuccess: (state) => {
      state.removeUserCollectionError = null;
      state.removeUserCollectionLoading = false;
    },
    removeUserFromCollectionFailure: (state, action) => {
      state.removeUserCollectionError = action.payload.message;
      state.removeUserCollectionLoading = false;
    },
    setSelectedUser: (state, action) => {
      state.selectEditUser = action.payload;
    },
    resetSelectedUser: (state) => {
      state.selectEditUser = null;
    },
    resetAlertBox: (state) => {
      state.addUserCollectionError = null;
      state.removeUserCollectionError = null;
    },
    resetSnackbar: (state) => {
      state.addUserStatus = 'idle';
      state.editUserStatus = 'idle';
      state.addUserError = null;
      state.editUserError = null;
    },
    getResetPasswordStart: (state) => {
      state.resetPwdLoading = true;
      state.resetPwdError = null;
    },
    getResetPasswordSuccess: (state) => {
      state.resetPwdLoading = false;
      state.resetPwdError = null;
    },
    getResetPasswordFailure: (state, action) => {
      state.resetPwdLoading = false;
      state.resetPwdError = action.payload.message;
    },
    deleteUserStart: (state) => {
      state.deleteUserStatus = 'loading';
      state.deleteUserError = null;
    },
    deleteUserSuccess: (state) => {
      state.deleteUserStatus = 'success';
      state.deleteUserError = null;
    },
    deleteUserFailure: (state, action) => {
      state.deleteUserStatus = 'fail';
      state.deleteUserError = action.payload.message;
    },
  },
});

export const {
  getCompanyUsersStart,
  getCompanyUsersSuccess,
  getCompanyUsersFailure,
  addUserStart,
  addUserSuccess,
  addUserFailure,
  editUserStart,
  editUserSuccess,
  editUserFailure,
  deleteUserStart,
  deleteUserSuccess,
  deleteUserFailure,
  fetchCompanyUsersStart,
  fetchCompanyUsersSuccess,
  fetchCompanyUsersError,
  fetchCollectionUsersStart,
  fetchCollectionUsersSuccess,
  fetchCollectionUsersError,
  addUserToCollectionStart,
  addUserToCollectionSuccess,
  addUserToCollectionFailure,
  removeUserFromCollectionStart,
  removeUserFromCollectionSuccess,
  removeUserFromCollectionFailure,
  setSelectedUser,
  resetSelectedUser,
  resetAlertBox,
  resetSnackbar,
  getResetPasswordStart,
  getResetPasswordSuccess,
  getResetPasswordFailure,
} = userSlice.actions;

export default userSlice.reducer;
